module.exports = __webpack_public_path__ + "img/UI_SSL_yuanbao_02_975565bc1.png";